import PortailUserAddRequestController from './user.add.request.list.controller';

export default {
    controller: PortailUserAddRequestController,
    template: require('./user.add.request.list.tpl.html')
};
